import React, { useEffect } from 'react';

const TermsOfService = () => {
  // Ensure we scroll to top when this component mounts
  useEffect(() => {
    const policyTop = document.getElementById('policy-top');
    if (policyTop) {
      policyTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div id="policy-top" className="policy-page container mx-auto px-6 pt-24 pb-20">
      <h1 className="text-3xl font-bold text-[#0E2556] mb-8">Terms of Service</h1>
      
      <div className="prose max-w-none text-gray-700">
        <p className="mb-4">Last Updated: March 21, 2025</p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="mb-4">
          Welcome to Senti.care. By accessing or using our website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">2. Use License</h2>
        <p className="mb-4">
          Permission is granted to temporarily access the materials on Senti's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
        </p>
        <ul className="list-disc pl-8 mb-4">
          <li>Modify or copy the materials;</li>
          <li>Use the materials for any commercial purpose;</li>
          <li>Attempt to decompile or reverse engineer any software contained on Senti's website;</li>
          <li>Remove any copyright or other proprietary notations from the materials; or</li>
          <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
        </ul>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">3. Disclaimer</h2>
        <p className="mb-4">
          The materials on Senti's website are provided on an 'as is' basis. Senti makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </p>
        <p className="mb-4">
          Further, Senti does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">4. Limitations</h2>
        <p className="mb-4">
          In no event shall Senti or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Senti's website, even if Senti or a Senti authorized representative has been notified orally or in writing of the possibility of such damage.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">5. Accuracy of Materials</h2>
        <p className="mb-4">
          The materials appearing on Senti's website could include technical, typographical, or photographic errors. Senti does not warrant that any of the materials on its website are accurate, complete, or current. Senti may make changes to the materials contained on its website at any time without notice. However, Senti does not make any commitment to update the materials.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">6. Links</h2>
        <p className="mb-4">
          Senti has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Senti of the site. Use of any such linked website is at the user's own risk.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">7. Modifications</h2>
        <p className="mb-4">
          Senti may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">8. Governing Law</h2>
        <p className="mb-4">
          These terms and conditions are governed by and construed in accordance with the laws of the United Kingdom and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">9. Healthcare Disclaimer</h2>
        <p className="mb-4">
          Senti provides technology and information for healthcare purposes, but does not provide medical advice. The content on our website is for informational purposes only and should not be considered a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of qualified healthcare providers with any questions you may have regarding medical conditions.
        </p>
        
        <h2 className="text-xl font-semibold text-[#0E2556] mt-8 mb-4">10. Contact Information</h2>
        <p className="mb-4">
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p className="mb-4">
          Email: <a href="mailto:info@senti.care" className="text-[#0E2556] hover:underline">info@senti.care</a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;